import { Helmet } from "react-helmet-async";

type PageHeadProps = {
  title: string;
  description?: string;
};

const PageHead: React.FC<PageHeadProps> = ({ title, description }) => {
  return (
    <Helmet>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
    </Helmet>
  );
};

export default PageHead;
